<template>
  <div class="page">
    <el-form :inline="true" ref="form" label-width="120px">
		<div style="display: flex;  justify-content:space-between;">
			<div>
				<div style="display: flex;align-items: center;">
					<el-form-item label="服务商">
						<el-cascader v-model="spIdDepartName" :options="providerOptions" :props="{ checkStrictly: true, expandTrigger: 'hover' }"></el-cascader>
					</el-form-item>	
					<el-form-item label="余额：" v-if="creditLimit !== '' && spBalance !== ''" style="margin-right: 50px; ">
					  <span style="color:red; background-color: #FFFFCC; padding: 10px 20px;">{{spBalance}}{{parseFloat(spBalance)>parseFloat(creditLimit)?'':'(已超额)'}}<i class="el-icon-info" style="font-size: 18px;color:#0066FF;"></i></span>
					</el-form-item>	
					<el-popover placement="right" :width="'176'" trigger="click" v-if="$qiniu != null && salesMan != null">
						<div v-if="salesMan.wechatQRCode != ''">
							<img :src="$qiniu.domain + salesMan.wechatQRCode" style="width: 150px;height: 150px;display: block;">
							<span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{salesMan.userName}}</span>
							<span style="display: block;color: teal;width: 150px;text-align: center;">{{salesMan.contacts}}</span>
						</div>
						<div style="display: flex; height: 40px; cursor: pointer;" slot="reference" v-if="salesMan != null">
							<font-awesome-icon :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69); font-size: 22px;" />
							<span style="color: rgb(42,161,69);font-size: 18px; font-weight: bold;">{{'业务:' + salesMan.userName}}</span>
						</div>									
					</el-popover>
				</div>
				<el-form-item label="科目">
				  <el-cascader v-model="subjectName" :options="advanceSubjectlist" :props="{ label:'value',emitPath:false }" placeholder="请选择科目" collapse-tags clearable></el-cascader>
				</el-form-item>	
				<el-form-item label="账单时间">
					<el-date-picker v-model="datetimerange[0]" type="date" value-format='yyyy-MM-dd HH:mm:ss' placeholder="开始日期">
					</el-date-picker>
					<label style="margin: 15px;">至</label>
					<el-date-picker v-model="datetimerange[1]" type="date" value-format='yyyy-MM-dd HH:mm:ss' placeholder="结束日期">
					</el-date-picker>
				</el-form-item>		
				<br/>
				<el-form-item label="是否付款">
					<el-radio-group v-model="tenantConfirmed">
						<el-radio :label="2">全部</el-radio>
						<el-radio :label="1">已付款</el-radio>
						<el-radio :label="0">待付款</el-radio>
					</el-radio-group>
				</el-form-item>									
			</div>
			<div>
				<el-input type="textarea" :rows="4" placeholder="请输入运单号或转单号，多个用逗号隔开" v-model="wayBillNos" @keyup.enter.native="submitForm" style="width: 300px;margin-right: 18px;margin-bottom: 18px;"></el-input>
				<div style="margin-bottom: 18px;margin-left: 18px;">
					<el-button type="primary" icon="el-icon-search" @click="queryAccountBill">查询</el-button>
					<el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
				</div>
			</div>
		</div>
		<div style="display: flex">
			<div style="margin-bottom: 18px;margin-left: 18px;">
			  <el-button icon="el-icon-download" @click="handleDownload">导出</el-button>
			  <el-button :disabled='!multipleSelection.length' @click="setremark">
				<font-awesome-icon icon="edit" style="margin-right: 5px;vertical-align: baseline;font-size: 10px;" />对账备注
			  </el-button>
			</div>	
			<div style="width: 20px"></div>
			<el-form-item>
				<span style="color: slategray; margin-right: 10px;">应付:</span>
				<el-radio-group v-model="billCountLabel" size="small" v-if="billCountList.length > 0" @change="billCountItemChanged">
				  <el-radio-button v-for="(item, k) in billCountList" :key="k" :label="getBillCountLabel(item)"></el-radio-button>
				</el-radio-group>							
			</el-form-item>
		</div>
    </el-form>
    <el-table-auto :ref="ref" id='bill' name='账单明细' :column='tableConf' :table-hand='getTable' :down-hand='paraphrase' @cell-dblclick='cellclickwayBillNo' @selection-change="handleSelectionChange" style="flex: 1;display: flex;flex-direction: column;overflow: hidden;" v-contextmenu:contextmenu>
      <template #spId="{row}">
        {{getSpName(row)}}
      </template>
      <template #billTime="{row}">
        {{getDatetime(row.billTime)}}
      </template>	  
      <template #wayBillNo="{row}">
        <span @click="cellclickwayBillNo(row)" class="blue">{{row.wayBillNo}}</span>
      </template>
      <template #tenantConfirmed="{row}">
        {{getTenantConfirmed(row)}}		  
      </template>	  
      <template #amount="{row}">
        <span style="font-weight: bold;">{{row.amount}}</span><i v-if="row.branchConfirmed" class="el-icon-check red" style="font-size: 16px;float: right;position: absolute;bottom: 0px;right: 0;font-weight: bold;"></i>
      </template>
      <template #postBalance="{row}">
        <span class="red" style="font-weight: bold;">{{row.postBalance}}</span>
      </template>
      <template #remark="{row}">
        <template v-if="row.remark && row.remark.indexOf('】')>-1">
          <span class="lins-tow">{{row.remark.substring(0,row.remark.indexOf('】')+1)}}</span>
          <span class="lins-tow gray">{{row.remark.substring(row.remark.indexOf('】')+1,row.remark.length)}}</span>
        </template>
        <span class="lins" v-else>{{row.remark}}</span>
      </template>
    </el-table-auto>
    <v-contextmenu ref="contextmenu" theme='default' style="z-index:auto">
      <v-contextmenu-item @click="copyclick">复制</v-contextmenu-item>
      <v-contextmenu-item :disabled='!multipleSelection.length' @click="getclientConfirmBill(1)">标识对账</v-contextmenu-item>
      <v-contextmenu-item :disabled='!multipleSelection.length' @click="getclientConfirmBill(0)">取消标识对账</v-contextmenu-item>
      <v-contextmenu-item :disabled='!multipleSelection.length' @click="setremark">对账备注</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
import Vue from 'vue'
import { page } from '@/mixins/page'
import * as date from '@/utils/date'
export default {
  mixins: [page],
  data() {
    return {
      ref: 'bill',
      subjectName: '',
	  providerOptions: [],
	  tenantConfirmed: 2,
	  spIdDepartName: [],
	  billCountList: [],
	  billCountLabel: '',
	  wayBillNos: '',
      // table
      tableConf: [
        //{ template: 'spId', label: '服务商', width: 90 },
        { template: 'billTime', label: '账单时间', width: 140 },
        { template: 'wayBillNo', label: '原单号', width: 120 },
        { prop: 'transBillNo', label: '转单号', width: 150 },
        { prop: 'spQuoteName', label: '渠道', width: 155 },
        { prop: 'destinationName', label: '目的地', width: 110 },
        { prop: 'pieces', label: '件数', width: 60 },
        { prop: 'weight', label: '结算重', width: 70 },
        { prop: 'goodsTypeName', label: '货物类型', width: 80 },
        { prop: 'subjectName', label: '科目', width: 105 },
        { template: 'tenantConfirmed', label: '状态', width: 80 },		
        { template: 'amount', label: '金额', width: 105 },
        { template: 'remark', label: '账单备注', width: 200 },
        { template: 'postBalance', label: '余额', width: 100 },
        { prop: 'branchRemark', label: '对账备注(服务商可见)', width: 160 },
        { prop: 'settlementCode', label: '结账编号', width: 160 }
      ],
      // 多选
      multipleSelection: []
    }
  },
  async mounted(){
	Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期		  
	let branchList = JSON.parse(localStorage.getItem('branchlist'))
	for(let i = 0, len = branchList.length; i < len; i++){		
		let option = {
			value: branchList[i].branchCode,
			label: branchList[i].branchName,
		}
		if(branchList[i].branchCode == '85689'){
			//LHD特殊处理
			let setting = await this.$api.getDepartmentSetting('85689')
			if(setting && setting.value){
				let departArr = setting.value.split(",")
				option.children = []
				departArr.forEach((departName)=>{
					let childOption = {
						value: departName,
						label: departName
					}
					option.children.push(childOption);
				})
			}
		}
		this.providerOptions.push(option)
	}
	if(this.providerOptions.length > 0){
		this.spIdDepartName = [this.providerOptions[0].value]
		this.spId = this.providerOptions[0].value
		this.getbinfo(this.spId)
	}
	this.queryBillCount()
  },
  methods: {
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 重置表格
    getReset() {
		this.spIdDepartName = []
		this.subjectName = ''
		this.datetimerange = [date.formatDate(new Date(new Date() - 1000 * 3600 * 24 * 10), 'yyyy-MM-dd hh:mm:ss'), date.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')]		
		this.tenantConfirmed = 2
    },
	billCountItemChanged(){
		for(let i = 0, len = this.billCountList.length; i < len; i++){
			if(this.billCountLabel == this.getBillCountLabel(this.billCountList[i])){
				this.spIdDepartName = []
				if(this.billCountList[i].spId){
					this.spIdDepartName.push(this.billCountList[i].spId)
					if(this.billCountList[i].spDepartName){
						this.spIdDepartName.push(this.billCountList[i].spDepartName)
					}
				}
				this.$refs[this.ref].currentChange(1)
				return;
			}
		}
	},	
	buildQueryParams(pages){
		let params = { ...pages, hidenInSettlement: '0' }
		if(this.spIdDepartName.length > 0){
			params.spId = this.spIdDepartName[0]
			if(this.spIdDepartName.length == 2){
				params.spDepartName = this.spIdDepartName[1]
			}
		}
		if(this.subjectName){
			params.subjectName = this.subjectName  
		} 	  
		if(this.tenantConfirmed < 2){
		  params.tenantConfirmed = this.tenantConfirmed
		}

		if (this.datetimerange) {
			params.startDate = this.datetimerange[0].substring(0, 10) + ' 00:00:00'
			params.endDate = this.datetimerange[1].substring(0, 10) + ' 23:59:59'
			params.timeType = 0
			if (params.startDate > params.endDate) {
				this.$message.warning('运单开始时间不能大于结束数据')
				return { list: [], total: 0 }
			}
		}
		this.wayBillNos = this.wayBillNos.trim().replaceAll('\n', ',')
		if (this.wayBillNos) {
			params = { ...pages, timeType: 0 }
			params.wayBillNos = this.wayBillNos
		}
		return params;
	},
	//查询
	async queryAccountBill(){
		this.$refs[this.ref].currentChange(1)
		this.queryBillCount()
	},
	async queryBillCount(){
		this.queryParams = this.buildQueryParams()
		let countList = await this.$api.getAccountBillCountList(this.queryParams)
		this.billCountList = []
		let total = 0
		let amount = 0
		if(countList.length > 0){
			this.billCountList.push({spId: '', spDepartName: '', billCount: 0, billAmount: 0})
			for(let i = 0, len = countList.length; i < len; i++){
				total += countList[i].billCount;
				amount += countList[i].billAmount;
				this.billCountList.push(countList[i]);
			}
			this.billCountList[0].billCount = total
			this.billCountList[0].billAmount = amount
			this.billCountLabel = this.getBillCountLabel(this.billCountList[0])
		}		
	},
    // 表格查询
    async getTable(pages) {
	  let params = this.buildQueryParams(pages)	
      //let { list, total } = await this.$api.billAdvanceAccountall(params)
      let { list, total } = await this.$api.getAccountBillPage(params)
      // 只显示结账单最后一条记录的余额,未结账的在最后一条记录显示当前余额
      let isemp = false
      let settlementCode = ''
      list.map(element => {
        if (!element.settlementCode) {
          if (!isemp) {
            isemp = true
          } else {
            element.postBalance = ''
          }
        } else {
          if (element.settlementCode == settlementCode) {
            element.postBalance = ''
          } else {
            settlementCode = element.settlementCode
          }
        }
      })
      return { list, total }
    },
    // 对账明细对账
    async getclientConfirmBill(flog) {
      try {
        await this.$api.confirmforbilldeat(this.multipleSelection, flog)
        await this.submitForm()
      } catch (error) {
        this.$message.warning(error)
      } finally {
      }
    },
	getSpName(row){
		if(row.spDepartName){
			return row.spDepartName;
		}else{
			return this.crrbranch(row.spId).branchName
		}
	},
	getBillCountLabel(item){
		if(item.spDepartName){
			return item.spDepartName + item.billAmount.toFixed(2)
		}
		if(item.spId){
			return this.crrbranch(item.spId).branchName + item.billAmount.toFixed(2)
		}
		return '全部' + item.billAmount.toFixed(2)
	},
	getTenantConfirmed(row){
		if((row.subjectCode) && (row.subjectCode != '4')){
			if(row.tenantConfirmed == 1){
				return '已付款'
			}else{
				return '待付款'
			}
		}else{
			return ''
		}
	},
    // 备注数据
    setremark() {
      if (this.multipleSelection.length != 1) return this.$notify.error('不可选择多条数据！')
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async ({ value }) => {
        // 按票备注(自己备注)：tenantId,spId,wayBillNo,tenantRemark,单条备注：tenantId,id,clientRemark（服务商备注）
        let data = { tenantId: localStorage.getItem('tenantId'), id: this.multipleSelection[0].id, clientRemark: value }
        await this.$api.costRecordremark([data])
        this.$notify.info('备注成功！')
        this.submitForm()
      })
    },
    // 导出字段转义
    paraphrase(row, template) {
      if (template == 'billTime') {
        return this.getDatetime(row.billTime)
      }
      if (template == 'spId') {
        return this.crrbranch(row.spId).branchName
      }
      if (template == 'remark') {
        if (row.remark && row.remark.indexOf('】') > -1) {
          return row.remark.substring(0, row.remark.indexOf('】') + 1) + row.remark.substring(row.remark.indexOf('】') + 1, row.remark.length)
        } else {
          return row.remark
        }
      }
    }
  }
}
</script>

<style scoped>
</style>